export enum EXAM_SIDE {
  NOT_BOTH = 'L',
  NOT_REQUIRED = 'N',
  NOT_SHOW = 'O',
  REQUIRED = 'S'
}

export enum MEDICAL_NUMBER_VISIBILITY {
  MANDATORY = 'O',
  NOT_SHOW = 'N',
  SHOW = 'V'
}

export enum TELECONSULTATION_TYPE {
  IN_PERSON = 'N',
  TELECONSULTATION = 'S',
  RESQUEST = 'R',
  WATING_LIST = 'L'
}

export enum TELECONSULTATION_EXPRESSION_TYPE {
  IN_PERSON = 'text.in-person',
  TELECONSULTATION = 'patient.teleconsultation',
  RESQUEST = 'patient.request',
  WATING_LIST = 'patient.label.modal-scheduling-waiting-list'
}

export enum COMPANY_VISIBILITY {
  HIDE = 'N',
  SHOW = 'V',
  MANDATORY = 'O',
}

export enum TASK_CHECKUP_LIST_VISIBILITY {
  NOT_SHOW = 'N',
  SHOW = 'V',
}

export enum GENDER_VISIBILITY {
  HIDE = 'N',
  SHOW = 'V',
  MANDATORY = 'O',
}

export enum PROFESSIONAL_VISIBILITY {
  HIDE = 'N',
  SHOW = 'V',
  MANDATORY = 'O',
}
